import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    private http = inject(HttpClient);

    constructor() { }

    get(): Observable<any> {
        return this.http.get(Global.url + 'V1/menus');
    }

    getById(id: any): Observable<any> {
        return this.http.get(Global.url + 'V1/menus/' + id);
    }

    create(data: any): Observable<any> {
        return this.http.post(Global.url + 'V1/menus', data);
    }

    update(id: any, data: any): Observable<any> {
        return this.http.put(Global.url + 'V1/menus/' + id, data);
    }

    delete(id: any): Observable<any> {
        return this.http.delete(Global.url + 'V1/menus/' + id);
    }

    bulkUpdate(menus: any[]): Observable<any> {
        return this.http.post(Global.url + 'V1/menus/bulk', menus);
    }
}
